$(document).ready(function () {
    if ($("#modal-promociones").length) {
        $("#modal-promociones").modal("show");

        $("#cerrar-modal-promocion").click(function () {
            $("#modal-promociones").modal("hide");
        });

        $("#modal-promocional-link").on("click", function (e) {
            $("#modal-promociones").modal("hide");
        });
    }
});
